export default {"src":"/_next/static/media/job-listing.f4f40bb4.svg","height":637,"width":495,"blurWidth":0,"blurHeight":0};